import { useState } from "react";
import { Link as WaspRouterLink, routes } from "wasp/client/router";
import { login } from "wasp/client/auth";
import { AuthPageLayout } from "./AuthPageLayout";
import { useQuery, getGlobalConfig } from "wasp/client/operations";

export default function Login() {
  const { data: config } = useQuery(getGlobalConfig);
  const isRegistrationEnabled = (config as any)?.registrationEnabled ?? true;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login({ email, password });
      // Redirect is handled automatically by Wasp after login if everything is set up correctly,
      // or we can manually redirect.
      window.location.href = "/dashboard";
    } catch (err: any) {
      setError(err?.message || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthPageLayout>
      <div className="w-full max-w-md mx-auto p-6">
        <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-gray-900 text-center">
          Login to your Account
        </h2>

        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email Address
            </label>
            <div className="mt-1">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 bg-white"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 flex justify-between">
              <span>Password</span>
              <WaspRouterLink
                to={routes.RequestPasswordResetRoute.to}
                className="text-xs text-blue-600 hover:underline"
              >
                Forgot your password?
              </WaspRouterLink>
            </label>
            <div className="mt-1">
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 bg-white"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {isRegistrationEnabled && (
          <div className="mt-6 text-center text-sm">
            <span className="text-gray-600">
              Don't have an account yet?{" "}
              <WaspRouterLink
                to={routes.SignupRoute.to}
                className="text-blue-600 hover:underline"
              >
                go to signup
              </WaspRouterLink>
              .
            </span>
          </div>
        )}
      </div>
    </AuthPageLayout>
  );
}
